export const CLINIC_INFO = {
  name: "CDH Sports- og Wellness Massage",
  owner: "Carsten Dalsgaard Hansen",
  address: "Banegårdspladsen 2, 6230 Rødekro",
  phone: "50 93 39 54",
  email: "info@cdhmassage.dk",
  openingHours: [
    { day: "Mandag", hours: "10.00-16.30 og 18.00-21.00" },
    { day: "Tirsdag", hours: "10.00-16.30 og 18.00-21.00" },
    { day: "Onsdag", hours: "10.00-16.30 og 18.00-21.00" },
    { day: "Torsdag", hours: "10.00-16.30 og 18.00-21.00" },
    { day: "Fredag", hours: "10.00-16.30 og 18.00-21.00" },
    { day: "Lørdag", hours: "10.00-15.00" },
    { day: "Søndag", hours: "10.00-15.00" },
  ],
};

export const TREATMENTS = [
  {
    id: "fysiurgisk-massage",
    category: "Dybdegående",
    title: "Fysiurgisk massage",
    description: "En dybdegående behandling, der fokuserer på at løsne spændinger og afhjælpe smerter i bevægeapparatet.",
    fullDescription: "Fysiurgisk massage er en dybdegående massageform, hvor massøren arbejder med muskulaturen for at afhjælpe spændinger og smerter. Denne form for massage er ideel til dig, der oplever specifikke problemer som nakkesmerter, lændeproblemer, spændingshovedpine eller sportsskader. Ved at øge blodcirkulationen og løsne op for de dybere muskellag, hjælper behandlingen med at genoprette kroppens naturlige balance og bevægelighed.",
    benefits: [
      "Afhjælper muskelspændinger",
      "Øger blodgennemstrømningen",
      "Reducerer stresshormoner",
      "Forbedrer restitution efter sport",
      "Lindrer smerter i ryg, nakke og skuldre"
    ],
    pricing: [
      { duration: "30 min", price: "305,-" },
      { duration: "45 min", price: "455,-" },
      { duration: "60 min", price: "610,-" },
      { duration: "90 min", price: "855,-" },
      { duration: "105 min (Helkrop)", price: "975,-" }
    ],
    image: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/16cbac27-44fe-4127-bb5c-5b182071dbd7.jpg"
  },
  {
    id: "massage-pistol",
    category: "Dybdegående",
    title: "Massage pistol",
    description: "Effektiv og målrettet behandling med moderne percussion teknologi.",
    fullDescription: "Massagepistolen er et effektivt supplement til den manuelle massage. Den bruger hurtige vibrationer og stød til at trænge dybt ind i muskelvævet. Dette hjælper med at nedbryde arvæv, løsne meget stive muskler og øge blodcirkulationen markant. Det er særligt effektivt til atleter eller personer med meget dybe spændinger.",
    benefits: [
      "Dybdegående vævsbehandling",
      "Hurtig restitution",
      "Løsner genstridige muskelknuder",
      "Øger bevægelighed"
    ],
    pricing: [
      { duration: "Som tillæg/del af behandling", price: "Se priser" }
    ],
    image: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/b2ceb7a6-9732-4a8c-8dd3-f0b038b63419.jpg"
  },
  {
    id: "wellness-massage",
    category: "Velvære",
    title: "Wellness massage",
    description: "En blid og afstressende massage, der giver fornyet energi og mental ro.",
    fullDescription: "Wellness massage er den ultimative selvforkælelse. Fokus her er ikke på dybe tryk, men på ro, harmoni og velvære. Behandlingen udføres med rolige strøg, der hjælper nervesystemet med at falde til ro og giver dig en pause fra hverdagens stress. Det er en ideel behandling, hvis du blot ønsker at koble af og give din krop og sjæl ny energi.",
    benefits: [
      "Dyb afspænding",
      "Mental ro og balance",
      "Reducerer træthed",
      "Giver fornyet energi",
      "Afstresser nervesystemet"
    ],
    pricing: [
      { duration: "45 min", price: "455,-" },
      { duration: "60 min", price: "610,-" },
      { duration: "90 min (Helkrop)", price: "855,-" }
    ],
    image: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/f3a66a30-9f56-48f2-9421-a97b8c94d32c.jpg"
  },
  {
    id: "lava-shell-massage",
    category: "Velvære",
    title: "Lava shell massage",
    description: "En varm og lindrende massage med polerede skaller fra Filippinerne.",
    fullDescription: "Lava Shell massage er en luksuriøs behandling, hvor varme tigerstribede muslingeskaller bruges til at massere kroppen. Varmen fra skallerne trænger dybt ind i musklerne og hjælper med at løsne spændinger hurtigere end ved traditionel massage. Det er en sanselig og ekstremt afslappende behandling, der kombinerer varmeterapi med dygtige massageteknikker.",
    benefits: [
      "Dyb varme lindrer muskelsmerter",
      "Forbedrer blodcirkulationen",
      "Ekstremt afslappende",
      "Unik sanselig oplevelse"
    ],
    pricing: [
      { duration: "Kontakt for info", price: "Varierer" }
    ],
    image: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/fc9e31a0-a8e6-4f4d-a18b-c7a0e7cba5b9.jpg"
  },
  {
    id: "massage-for-2",
    category: "Velvære",
    title: "Massage for 2 personer",
    description: "Del en afslappende oplevelse med en du holder af i samme rum.",
    fullDescription: "Nyd en fælles massageoplevelse, hvor I begge bliver behandlet i samme rum af to massører. Det er den perfekte måde at dele en stund af velvære med en partner, ven eller familiemedlem. I kan vælge mellem forskellige massageformer, så behandlingen passer præcis til jeres individuelle behov.",
    benefits: [
      "Fælles oplevelse af velvære",
      "Behandling i samme rum",
      "Vælg individuel massageform",
      "Perfekt som gave"
    ],
    pricing: [
      { duration: "Kontakt for pris", price: "Varierer" }
    ],
    image: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/4c48fd63-ed8b-4df1-ac7c-50108cca86e0.jpg"
  },
  {
    id: "gravid-massage",
    category: "Andet",
    title: "Gravid massage",
    description: "Skånsom behandling tilpasset den gravide krop for lindring og velvære.",
    fullDescription: "Under en graviditet gennemgår kroppen store forandringer, hvilket kan medføre belastning af ryg, lænd og bækken samt vand i benene. Gravid massage tager højde for disse udfordringer og udføres på en måde, der er sikker for både mor og barn. Jeg har fokus på at skabe en tryg og behagelig oplevelse, der lindrer gener og giver dig en velfortjent stund med fuld fokus på dig selv.",
    benefits: [
      "Lindrer lænde- og bækkensmerter",
      "Reducerer hævelser i ben og fødder",
      "Forbedrer søvnkvaliteten",
      "Giver ro og velvære til mor og barn",
      "Løsner spændte muskler"
    ],
    pricing: [
      { duration: "75 min", price: "750,-" }
    ],
    image: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/a22ab241-dd72-4474-b51a-3f25da5e73d1.jpg"
  },
  {
    id: "ir-sauna",
    category: "Velvære",
    title: "Infrarød Sauna (IR Sauna)",
    description: "Her har du mulighed for at booke tid til en tur i en infrarød sauna her i klinikken – Enten som en kombination med en massage eller ”bare” sauna.",
    fullDescription: "En infrarød Sauna er i sagens natur \"bare\" en sauna, men som på nogle punkter er meget forskellig fra den tradionelle sauna.\nI en infrarød sauna bliver du varmet op af infrarød strålevarme (direkte varme), som trænger ind i kroppen (ca 4 cm) og giver en fornemmelse af at blive varm \"indefra\".\nI en traditionel sauna bliver du varmet op at den varme luft (Indirekte varme) i saunaen, som giver en mere overfladisk varme.\nEn traditionel sauna er ofte 90-100 grader varm og har en meget høj luftfugtighed.\nIr sauna er typisk kun mellem 45-55 grader og luften er tør.\nSå har du ligesom jeg svært ved at få luft/trække vejret i en traditionel sauna, så er ir sauna måske en mulighed for dig.",
    benefits: [
      "Øger velvære og energiniveau",
      "Afgifter og styrker immunforsvaret",
      "Positiv virkning på søvnløshed",
      "Øger blodcirkulationen",
      "Virker muskelafslappende",
      "Lindre smerter i led, ryg og muskler",
      "Optimerer musklernes evne til at restituere efter sport",
      "Positiv indvirkning på depression",
      "Virker generelt afslappende, og kan derfor have positiv effekt på stress"
    ],
    benefitsFooter: "WELLNESS – for dig der elsker varme",
    pricing: [
      { duration: "30 min", price: "150,-" },
      { duration: "45 min", price: "200,-" },
      { duration: "60 min", price: "250,-" },
      { duration: "Ekstra person (Tillæg for 2. og 3. person)", price: "75,- pr. person" },
      { duration: "30 min (v/ massage)", price: "100,-" },
      { duration: "45 min (v/ massage)", price: "150,-" }
    ],
    image: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/e335ebc2-29a7-4c25-b1ca-a107636b074a.png",
    cardImage: "https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/8a94b928-b176-4961-8e1b-ec7cf5e28952.jpg",
    towels: {
      title: "Håndklæder?",
      text: "Da du SKAL sidde/ligge på et håndklæde, får du udleveret 2 store håndklæder til låns.\nDet er en del af prisen, så det behøver du ikke selv at medbringe"
    },
    clothing: {
      title: "Med eller uden tøj?",
      text: "Om du vælger at sidde i badetøj, undertøj eller helt uden tøj er op til dig selv.\nHvis du vælger at sidde i badetøj eller undertøj vil jeg anbefale at du har skiftetøj med til bagefter. Man kan komme til at svede en del."
    },
    contraindications: {
      title: "Hvad taler imod Infrarød Sauna?",
      subtitle: "Selvom der er mange fordele ved at benytte sig af en Infrarød Sauna, så er der også ting, der taler imod.",
      list: [
        "Feber",
        "graviditet",
        "Amning",
        "Kirugiske implantater",
        "Dissemineret sklerose",
        "Lupus",
        "Hemophiliacs",
        "Nye sår",
        "Kirugisk nyligt lukkede sår",
        "Pacemaker",
        "Hjerteproblemer"
      ],
      warning: "Konsulter altid egen læge, hvis du er i tvivl eller ved indtagelse af receptpligtig medicin.\n\nGå aldrig i Infrarød Sauna, hvis du har indtaget alkohol eller andre rusmidler, da dette kan medføre bevidstløshed."
    }
  }
];

export const ABOUT_CONTENT = {
  name: "Carsten Dalsgaard Hansen",
  titles: [
    "Lægeeksamineret fysiurgisk sportsmassør",
    "Selvstændig siden 2012"
  ],
  bio: "Jeg blev uddannet i februar 2012 og startede som selvstændig massør den 1. september 2012. Min klinik har fokus på den enkelte klients behov, uanset om det drejer sig om sportsskader, hverdagens spændinger eller behovet for ren afslapning.",
  approach: [
    { title: "Erfaring", description: "Med over 10 års erfaring som massør har jeg behandlet et bredt spektrum af problematikker." },
    { title: "Faglighed", description: "Som lægeeksamineret massør sikrer jeg en høj faglig standard i alle behandlinger." },
    { title: "Personlig behandling", description: "Ingen kroppe er ens. Jeg tilpasser altid min teknik til netop din krop og dine udfordringer." },
    { title: "Rolig og tryg tilgang", description: "Det er vigtigt for mig, at du føler dig tryg og afslappet fra det øjeblik, du træder ind i klinikken." }
  ]
};

export const COURSE_CONTENT = {
  title: "Wellness massage - kursus",
  description: "Kurset skal ses som inspiration til hvordan man kan opbygge en skøn wellness massage, med lange blide strøg. Du lærer nogle forskellige greb og strøg, der så bliver sat sammen til en ca. 45 min massage.",
  videoUrl: "/images/video/massage-4.mp4",
  warning: "Du lærer altså IKKE dybdegående massage, til behandling af f.eks. spændingshoved og lændesmterter.",
  whoCanParticipate: "Alle der har lyst til at lære at give en Wellness massage er velkommen til at deltage i dette kursus. Der er ingen krav til forudgående kendskab til at massere.",
  types: [
    {
      title: "Kursus – Hold",
      subtitle: "Alle lærer at massere - 4,5 timer",
      description: "Kursus for alle der har lyst (mænd, kvinder, singler, par). Der skal være min 3 og max 4 deltagere, for at kurset bliver til noget. Afholdes på fastlagte datoer (typisk lørdag eller søndag fra 10.00-14.30). Tilmelding forgår via min hjemmeside (Online booking).",
      extra: "Er I 4 der tilmelder sig sammen, kan dato og tidspunkt aftales individuelt. Kan være aften eller weekend. Ring eller skriv til mig, så finder vi en dato sammen på 50 93 39 54 eller info@cdhmassage.dk",
      price: "500,- pr. person"
    },
    {
      title: "Kursus – For 2 personer",
      subtitle: "Begge personer lærer massagen - 4 timer",
      description: "Kursus for kun 2 deltagere (f.eks. par, venner, veninder). Book tid online, eller tag fat i mig på 50 93 39 54, hvis I ønsker en aften eller weekend.",
      price: "1400,- (700,- pr. person)"
    },
    {
      title: "Kursus – For par eller enlige",
      subtitle: "Hvor det kun er den ene part der lærer massagen - 2,5 timer",
      description: "Kursus for kun 2 deltagere (f.eks. par, venner, veninder eller singler). Er du single eller har ikke mulighed for at få en anden person med som vil ligge på briksen, så vil jeg prøve at finde en frivillig.",
      price: "875,-"
    }
  ],
  practical: [
    "Da der igennem store dele af massagen bliver masseret fra top til tå, ligger man i undertøj eller helt uden. Det bestemmer man naturligvis selv.",
    "Der vil være vand, kaffe, the og frugt i køkkenet.",
    "Der er parkering lige ved døren.",
    "Kurset afholdes i Blans på Mejeritoften 23 - Hvor jeg har klinik."
  ],
  remember: [
    "Ønsker du ikke at ligge helt afklædt (nøgen) anbefaler jeg at du tager noget skifteundertøj med, da der bliver brugt en del olie, og tøjet bliver fedtet når man masserer henover det.",
    "Boksershorts er en dårlig ide.",
    "Jeg har lagener og håndklæder, som du kan låne (inkluderet i prisen)."
  ],
  registration: {
    methods: "Via Online booking på min hjemmeside – www.cdhmassage.dk eller ved at kontakte mig på 50 93 39 54.",
    payment: "Når man har tilmeldt sig et HOLD-kursus har man 2 hverdage til at betale for kurset (mobile pay : 27226 eller bankoverførsel : 9731-11104002). Skriv navn og at det er kursus der betales for ved overførsel.",
    note: "Tilmelding gælder først når betaling for kurset er registreret. Datoer for kommende kurser findes under online booking."
  }
};
